import requestAxios from '@/utils/request'

export function getSettingScoreApi (params) {
  return requestAxios.get('enter-score/setting', {params})
}

export function settingScoreApi (data) {
  return requestAxios.post('enter-score/setting', data)
}



// WEBPACK FOOTER //
// ./src/api/enter-score/setting.js